import 'mutationobserver-shim';
import Vue from 'vue';
import VueRouter from 'vue-router'
import './plugins/bootstrap-vue';
import App from './VoicesApp.vue';
import PipiPupuAPIClient from './PipiPupuAPIClient';
import 'allsettled-polyfill';
import PublicVoices from './components/Public/Voices.vue';

Vue.use(VueRouter);
Vue.config.productionTip = false;
Vue.prototype.$baseUrl = process.env.VUE_APP_PIPIPUPUBASE || `${location.protocol}//${location.host}`;
Vue.prototype.$api = new PipiPupuAPIClient(`${process.env.VUE_APP_PIPIPUPUBASE||''}/api`, Vue.prototype.$auth);
Vue.prototype.$util = {
	load(promise) {
		this.loading++;
		return promise.catch(err => {
			this.error = err&&err.error||err.toString();
		}).finally(() => {
			this.loading--;
		});
	},
	copyToClipboard(text, parentElement) {
		let el = document.createElement('textarea');
		el.value = text;
		parentElement = parentElement || document.body;
		parentElement.appendChild(el);
		el.select();
		document.execCommand('copy');
		parentElement.removeChild(el);
	},
};

new Vue({
	router: new VueRouter({
		mode: 'history',
		base: '/voices',
		linkActiveClass: 'active-tree',
		linkExactActiveClass: 'active',
		routes: [
			{ path: '/', name: 'PublicVoices', component: PublicVoices },
			{ path: '/:plan', name: 'PublicVoices', component: PublicVoices },
		],
	}),
	render: h => h(App),
}).$mount('#app');
